import { InjectionToken } from '@angular/core';
import { UserDTO } from '@activia/cm-api';
import { Observable } from 'rxjs';

export interface IMessengerConfig {
  authenticatedUser$: Observable<UserDTO>;
  isUserOnline$: Observable<boolean>;
}
export const MESSENGER_CONFIG = new InjectionToken<IMessengerConfig>('MESSENGER_CONFIG');
